const validateInputArray = (dataList, config, validate, validationArgs, snackbarAlert, errorList, setErrorList, transform, transformArgs) => {
    for (let i = 0; i < dataList.length; i++) {
        // validate row
        let checkError = validate(dataList[i], config, validationArgs, snackbarAlert); 
        // actions if error
        if (checkError) {
            setErrorList(setErrorList => setErrorList = [
                ...setErrorList.slice(0, i),
                {
                    ...setErrorList[i], 
                    [checkError]: true,
                }, 
                ...setErrorList.slice(i+1, setErrorList.length),                         
            ]); 
            // return to stop request
            return true; 
        }
        // actions if no error 
        else {
            // set error list 
            let errorObj = {}
            Object.keys(errorList[i]).map((el) => {
                errorObj[el] = false; 
            }); 
            setErrorList(setErrorList => setErrorList = [
                ...setErrorList.slice(0, i),
                errorObj, 
                ...setErrorList.slice(i+1, setErrorList.length),                         
            ]); 
            // if no error, run transformation function 
            dataList[i] = transform(dataList[i], config, transformArgs); 
        }
    }
    // if no error on any rows return false
    return false; 
}

export default validateInputArray; 